	
<template>
   <div class="d-flex flex-column justify-content-center gap-6 border rounded p-3 bg-light  m-3">
    <button 

      type="button"
      class="btn mb-2 btn-outline-success"
      data-bs-toggle="popover"
      :title="title"
      :data-bs-content="content">
       5. Artificial Intelligence (AI) Layer <i class="bi bi-info-circle"></i>
    </button>
  </div>
  <div class="d-flex justify-content-center gap-4">
    <div 
      v-for="(group, gIndex) in buttonGroups" 
      :key="gIndex" 
      class="d-flex flex-column-reverse align-items-center border rounded p-3 bg-light"
    >
      <!-- Main button -->
      <button 
        type="button" 
        class="btn mt-2"
        style="width: 12rem;"
        :class="group.main.class">
        {{ group.main.label }}
      </button>

      <!-- Child buttons -->
      <div class="d-flex flex-column-reverse border rounded p-3 bg-light">
        <button
          v-for="(btn, index) in group.children"
          :key="index"
          type="button"
          class="btn mb-2 w-100"
          :class="btn.class"
          data-bs-toggle="popover"
          :title="btn.label"
          :data-bs-content="btn.content"
        >
          {{ btn.label }} <i class="bi bi-info-circle"></i>
        </button>
      </div>
    </div>
  </div>
    <div class="d-flex flex-column justify-content-center gap-6 border rounded p-3 bg-light  m-3">
    <button 

      type="button"
      class="btn mb-2 btn-outline-success"
      data-bs-toggle="popover"
      :title="content"
      >
        1. Linux (Ubuntu) <i class="bi bi-info-circle"></i>
    </button>
  </div>
</template>



<script>
//import * as bootstrap from 'bootstrap'   // <-- add this
//import { Tooltip } from 'bootstrap';
//import { Popover } from 'bootstrap'  // ✅ Only import what you need
export default {
  name: "InfoButtons",
  data() {
   return {
    buttonGroups: [

     {
        main: { label: "2. IoT/Embedded Systems", class: "btn btn-outline-success" },
        children: [
          { label: "Robotics", class: "btn btn-outline-secondary", content: "What was good and bad?" },
          { label: "Drones", class: "btn btn-outline-secondary", content: "What else could you have done?" },
          { label: "Headless Devices", class: "btn btn-outline-secondary", content: "What else could you have done?" },
          { label: "Automations/Sensors", class: "btn btn-outline-secondary", content: "What else could you have done?" }
        ]
      }, 
   
      {
        main: { label: "3. Cybersecurity", class: "btn btn-outline-success" },
        children: [
          { label: "Firewalls", class: "btn btn-outline-secondary", content: "What was good and bad?" },
          { label: "Security Tools", class: "btn btn-outline-secondary", content: "What else could you have done?" },
          { label: "Device Authentication", class: "btn btn-outline-secondary", content: "What else could you have done?" },
          { label: "Network Appliances", class: "btn btn-outline-secondary", content: "What else could you have done?" }
        
        ]
      },
         {
        main: { label: "4. Cloud  Servers", class: "btn btn-outline-success" },
        children: [
          { label: "AWS", class: "btn btn-outline-secondary", content: "What happened?..." },
          { label: "AZURE", class: "btn btn-outline-secondary", content: "What were you thinking?..." },
          { label: "VPS", class: "btn btn-outline-secondary", content: "What were you thinking?..." },
          { label: "VPN", class: "btn btn-outline-secondary", content: "What were you thinking?..." }
        ]
      },
      
    ]
  }
  },
  /*
  mounted() {
    // Initialize Bootstrap popovers when component mounts
    const popoverTriggerList = [].slice.call(
      this.$el.querySelectorAll('[data-bs-toggle="popover"]')
    )
    popoverTriggerList.map(el => new bootstrap.Popover(el))
  }
}
mounted() {
    // ✅ Initialize Bootstrap popovers locally for this component
    const popoverTriggerList = Array.from(
      this.$el.querySelectorAll('[data-bs-toggle="popover"]')
    )
    popoverTriggerList.forEach(el => new Popover(el))
  }*/
}
</script>